import { render, staticRenderFns } from "./HeaderTabs.vue?vue&type=template&id=7a17d7d6&scoped=true"
import script from "./HeaderTabs.vue?vue&type=script&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&lang=js"
import style0 from "./HeaderTabs.vue?vue&type=style&index=0&id=7a17d7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a17d7d6",
  null
  
)

export default component.exports